/**
 * promotional-offer.js
 * Updates promo offer banners dynamically when cart total changes.
 * Reads threshold and money format from data-* attributes set by Liquid.
 * Compatible with Dawn's cart.js updateQuantity flow.
 */

function updatePromoOfferBanners(cartTotal) {
  const slots = document.querySelectorAll('[id^="promo-offer-slot-"]');
  if (!slots.length) return;

  slots.forEach((wrapper) => {
    const threshold   = parseInt(wrapper.dataset.threshold, 10);
    const moneyFormat = wrapper.dataset.moneyFormat;
    const statusEl    = wrapper.querySelector('.promo-offer-banner__status');

    if (!statusEl) return;

    const qualified       = cartTotal >= threshold;
    const remainingCents  = Math.max(threshold - cartTotal, 0);
    const remainingAmount = (remainingCents / 100).toFixed(2);

    // Format remaining amount using Shopify money format
    const remainingFormatted = moneyFormat.replace('{{amount}}', remainingAmount);

    if (qualified) {
      wrapper.classList.add('promo-offer-banner--qualified');
      statusEl.classList.add('promo-offer-banner__status--qualified');
      statusEl.innerHTML = "✓ Your order qualifies — we'll include this with your shipment.";
    } else {
      wrapper.classList.remove('promo-offer-banner--qualified');
      statusEl.classList.remove('promo-offer-banner__status--qualified');
      statusEl.innerHTML = `Add ${remainingFormatted} more to unlock this offer.`;
    }
  });
}

// Hook into Dawn's cart update events
// Dawn dispatches 'cart:updated' and also updates via CartItems class
document.addEventListener('cart:updated', (event) => {
  if (event.detail && event.detail.cart) {
    updatePromoOfferBanners(event.detail.cart.total_price);
  }
});

// Fallback: observe DOM for cart total changes (covers drawer updates)
// Dawn re-renders cart totals into elements with data-cart-total
const cartTotalObserver = new MutationObserver(() => {
  const cartTotalEl = document.querySelector('[data-cart-total]');
  if (cartTotalEl) {
    const total = parseInt(cartTotalEl.dataset.cartTotal, 10);
    if (!isNaN(total)) updatePromoOfferBanners(total);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const cartContainer = document.querySelector('#cart-notification, cart-drawer, .cart__items');
  if (cartContainer) {
    cartTotalObserver.observe(cartContainer, { subtree: true, childList: true });
  }
});
